import { OnInit, Component, OnDestroy } from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
// import { PRODUCT_TS } from '../MainComponent';
import { TokenStorage } from 'providers/TokenStorage';
import { OptionsHttp } from 'providers/http/OptionsHttp';
import { MainHttp } from 'providers/http/MainHttp';
import { LoginHttp } from 'providers/http/LoginHttp';
import { MessageStorage } from 'util/MessageStorage';
import { ApplicationsHttp } from 'providers/http/ApplicationsHttp';
import { INVALID_TOKEN_PRODUCT } from 'providers/http/ErrorInterceptor';

declare let SYSTEM_CONST;
declare let PRODUCT;

@Component({
    selector: 'lobby',
    templateUrl: './Lobby.html',
    styleUrls: ['./Lobby.css'],
    providers: []
})
export class Lobby implements OnInit, OnDestroy {
    body = $('body');
    visible = 'menubar-visible';
    fullHeigth = $('body').height() - 72;
    PRODUCT: any;
    // loggedUser: any = {};
    username: any = '';
    profileImage: any = '';
    initialsName: any = '';
    menuOpen: any = true;
    subItemObj: any = {};
    modulesOptions: any = {};
    selectedModule: any = 0;
    currentOption = '';
    errorMessage: string;
    /**
     * determina si el header es visible o no
     */
    headerFlag = true;

    visibleSplash = true;

    SYSTEM_CONST: any;
    /**
     * actual usuario logeado
     */
    currentUserId: string;
    products = [
        {name: 'LudyOrder', url: '#/app/home' },
        {name: 'LudyMeter', url: '#/app/home' }
    ];
    productList = [];
    msg: any;
    msgType: any;
    validUser = false;
    alive = true;
    private subsPro;
    constructor(private router: Router,
        private routeLocation: ActivatedRoute,
        private tokenStorage: TokenStorage,
        private optionsHttp: OptionsHttp,
        private applicationsHttp: ApplicationsHttp,
        private mainHttp: MainHttp,
        private loginHttp: LoginHttp,
        private sanitizer: DomSanitizer) {
        this.msg = this.routeLocation.snapshot.queryParams.msg;
        this.msgType = this.routeLocation.snapshot.queryParams.msgType;
        this.PRODUCT = PRODUCT.LUDYACCOUNT;
        this.products = [];
    }

    getProductsAgent() {
        if ( this.alive ) {
            this.subsPro =  this.applicationsHttp.getProductsAgent({})
            .subscribe((resp) => {
                this.productList = resp.ProductForAgentList;
                this.showSplash();
                setTimeout(() => {
                    this.getProductsAgent();
                    // 30 minutos = 1800000 milisegundos
                }, 1800000);
            });
        }
    }

    getLoggedUserData() {
        this.mainHttp.getLoggedUserData().then((response) => {
            if (response != null) {
                if (response.firstName != null && response.firstName != '') {
                    if (response.lastName != null && response.lastName != '') {
                        this.username = response.firstName + ' ' + response.lastName;
                    } else {
                        this.username = response.firstName;
                    }
                } else {
                    this.username = response.username;
                }
                if (response.profileImageUrl == null || response.profileImageUrl == '') {
                    if (response.initialsName == null || response.initialsName == '') {
                        this.profileImage = 'images/user2.jpg';
                        $('#usernameProfile').removeClass('top-username-initials-name');
                    } else {
                        this.initialsName = response.initialsName;
                        $('#usernameProfile').addClass('top-username-initials-name');
                        this.profileImage = null;
                    }
                } else {
                    this.profileImage = response.profileImageUrl;
                    $('#usernameProfile').removeClass('top-username-initials-name');
                }
                this.currentUserId = response.agentId;
                this.showSplash();
            }
        });
    }

    showSplash(remove?) {
        if (((this.productList && this.productList.length > 0) && (this.currentUserId && this.currentUserId !== '') && this.validUser) || remove) {
            $('#splash').remove();
            this.visibleSplash = false;
        } 
    }

    validate() {        
        if ((this.tokenStorage.getToken() !== undefined && this.tokenStorage.getCookie() !== undefined) ||
            (this.tokenStorage.getToken() !== null && this.tokenStorage.getCookie() !== null)) {
            this.loginHttp.validateToken().subscribe((response) => {
                this.validUser = true;
                this.showSplash();

            }, (error) => {
                this.validUser = false;
                this.showSplash(true);
                if (error.errorCode == 0) {
                    this.tokenStorage.resetToken();
                    this.tokenStorage.deleteCookie();
                    window.location.href = '#login?msg=No es posible establecer conexión con el servidor.&msgType=warning';   
                } else if (error.errorCode  == INVALID_TOKEN_PRODUCT) {
                    // this.tokenStorage.resetToken();
                    // window.location.href = `#/lobby?msg=${error.errorMessage}&msgType=info`;
                } else {
                this.tokenStorage.resetToken();
                this.tokenStorage.deleteCookie();
                window.location.href = '#login';
                }
            });
        }
        else {
            window.location.href = '#login';
        }
    }

    logOut() {
        this.loginHttp.logOut().subscribe((response) => {
            this.tokenStorage.resetToken();
            this.tokenStorage.deleteCookie();
        },
        (error) => {
            MessageStorage.add('error', error.errorMessage);
        });
        this.tokenStorage.resetToken();
        this.tokenStorage.deleteCookie();
        // localStorageFilter.set('dash',null);
        localStorage.reloadToLudyAccount = 'true';
        window.location.href = '#/login';
    }

    homeClick() {
        this.selectedModule = 'dash-000';
        this.router.navigateByUrl('/lobby');
    }

    productsClick(product) {
        let token: any;
        if ( this.tokenStorage.getToken() ) {
            token = this.tokenStorage.getToken();
        } else if ( this.tokenStorage.getCookie() ) {
            token = this.tokenStorage.getCookie();
        }
        let url = '';

        if ( product.ACTIVO === 'A' ) {
            if ( product.IDPRODUCT === '04') {
                this.router.navigate(['/app/home']);
            } else {
                url = product.URLAPP;
                // window.open(usrl, '_blank');
                location.href = url;
            }

        } else {
            url = product.URLAPP;
            window.open(url , '_blank');
        }
    }

    showMessage() {
        if ( this.msg && this.msgType ) {
            MessageStorage.add(this.msgType, this.msg);
        }
    }

    ngOnInit() {
        this.showMessage();
        this.getProductsAgent();
        this.getLoggedUserData();
        $('body').removeAttr('style');
        $('body').removeClass().addClass('home-body');
        this.validate();
    }

    ngOnDestroy() {
        this.subsPro.unsubscribe();
        this.alive = false;
    }
}
